<template>
  <div class="add-edit-user">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-text>
          <div class="d-flex justify-space-between pt-2">
            <h3 class="black--text">{{ edit ? "Edit" : "Add" }} User</h3>
            <v-icon @click="close">mdi-close</v-icon>
          </div>
          <v-divider class="black--text"></v-divider>

          <div>
            <v-form ref="form" lazy-validation @submit.prevent="save">
              <v-card flat>
                <v-card-text class="px-0">
                  <v-row no-gutters>
                    <v-col cols="12" md="6" class="pr-md-1">
                      <v-text-field
                        v-model="user.first_name"
                        label="First Name"
                        :rules="[v => !!v || 'First Name is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pl-md-1">
                      <v-text-field
                        v-model="user.last_name"
                        label="Last Name"
                        :rules="[v => !!v || 'Last Name is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-model="user.email"
                    label="Email"
                    :rules="[v => !!v || 'Email is required']"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model="user.address.add_line_1"
                    label="Address Line 1"
                    :rules="[v => !!v || 'Address Line 1 is required']"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model="user.address.add_line_2"
                    :rules="[v => !!v || 'Address Line 2 is required']"
                    label="Address Line 2"
                    outlined
                    dense
                  ></v-text-field>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="user.address.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="px-md-2">
                      <v-autocomplete
                        v-model="user.address.state"
                        label="State"
                        :rules="[v => !!v || 'State is required']"
                        :items="states"
                        item-text="name"
                        item-value="value"
                        outlined
                        dense
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="user.address.zip"
                        label="Zip"
                        :rules="[v => !!v || 'Zip is required']"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-select
                    v-model="user.is_suspended"
                    label="Status"
                    :items="[
                      { name: 'Active', value: false },
                      { name: 'Suspended', value: true }
                    ]"
                    item-value="value"
                    item-text="name"
                    outlined
                    dense
                  ></v-select>
                  <v-autocomplete
                    v-model="user.access_role"
                    label="Roles"
                    :items="[
                      'admin',
                      'contractor',
                      'dealer',
                      'projects',
                      'architect',
                      'support'
                    ]"
                    :rules="[v => (!!v && v.length) || 'Role is required']"
                    outlined
                    multiple
                    small-chips
                    deletable-chips
                    dense
                  ></v-autocomplete>
                </v-card-text>
              </v-card>

              <v-btn
                color="primary"
                type="submit"
                :loading="saveLoading"
                class="white--text mr-1 px-4"
                depressed
                >Save</v-btn
              >
              <v-btn
                color="black"
                class="px-4"
                :disabled="saveLoading"
                outlined
                depressed
                @click="$emit('close')"
                >Cancel</v-btn
              >
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import states from "@/configs/states.json";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      states,
      saveLoading: false,
      user: {}
    };
  },
  created() {
    if (this.userInfo) {
      this.user = { ...this.userInfo };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    refresh() {
      this.$emit("refresh");
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.edit) {
          this.updateUser();
        } else {
          this.createUser();
        }
      }

      //   if (this.edit) {
      //     this.updateUser();
      //   } else {
      //     this.createUser();
      //   }
    },
    createUser() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.$store
          .dispatch("user/createUser", this.project)
          .then(() => {
            this.refresh();
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },
    updateUser() {
      if (this.$refs.form.validate()) {
        const payload = {
          email: this.userInfo.email,
          data: {
            new_email: this.user.email,
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            is_suspended: this.user.is_suspended,
            access_role: this.user.access_role,
            address: this.user.address
          }
        };

        if (this.userInfo.email !== this.user.email) {
          payload.data.new_email = this.user.email;
        } else {
          payload.data.new_email = null;
        }

        this.saveLoading = true;
        this.$store
          .dispatch("adminUser/updateAdminUser", payload)
          .then(() => {
            this.refresh();
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    }
  }
};
</script>
